// extracted by mini-css-extract-plugin
export var altaccent = "ResourceCard-module--altaccent--f37a0";
export var arrow = "ResourceCard-module--arrow--8cef6";
export var businessUnit = "ResourceCard-module--business-unit--7ef42";
export var cardLayout = "ResourceCard-module--card--layout--dbdcc";
export var date = "ResourceCard-module--date--9b9ec";
export var footer = "ResourceCard-module--footer--f2e81";
export var header = "ResourceCard-module--header--91010";
export var link = "ResourceCard-module--link--db3bd";
export var listLayout = "ResourceCard-module--list--layout--bf7b4";
export var resourceCard = "ResourceCard-module--resource-card--18336";
export var thumbnail = "ResourceCard-module--thumbnail--48772";
export var type = "ResourceCard-module--type--a39f7";